var React = require('react');

function ExternalLink (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.67278 1.25L6.67278 0L11.9226 8.76654e-06L11.9226 5.24978L10.6726 5.24977L10.6726 2.13324L5.48364 7.32223L4.60001 6.4386L9.7886 1.25L6.67278 1.25Z","key":0}),React.createElement("path",{"d":"M0 1H5V2.5H1.5V10.5H9.5V7H11V12H0V1Z","key":1})]);
}

ExternalLink.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = ExternalLink;

ExternalLink.default = ExternalLink;
